module.exports = __webpack_public_path__ + "static/media/MTL_SL_RMA7024.c89ee056.png";